import React, { useEffect, useState } from 'react';
import { Card } from '@mantine/core';
import Button from '../../components/elements/Button';
import IconArrowLeft from '../../components/icons/IconArrowLeft';
import { useDispatch, useSelector } from 'react-redux';
import { setCountTime } from './actions';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearStorages, getUserData, getTempToken } from '../../utils/storage';
import IconWarning from '../../components/icons/IconWarning';
import { useTimer } from 'react-timer-hook';
import ModalExpiredToken from '../../components/fragments/ModalExpiredToken';
import styles from './styles.scoped.css';

const ConnectApp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = getUserData();
  const location = useLocation();
  const userTempToken = getTempToken();

  const [ isDisabled, setIsDisabled ] = useState(true);
  const { btnCountTime, qrCountTime } = useSelector( s => s.mfa);
  const [ modal, setModal ] = useState(false);
  const { btnCountDown, qrCountDown } = location.state || {};
  const { seconds, restart: restartBtnTimer } = useTimer({
    expiryTimestamp: new Date(),
    onExpire: () => setIsDisabled(false),
    autoStart: false
  });
  const { restart: restartQrTimer } = useTimer({
    expiryTimestamp: new Date(),
    onExpire: () => setModal(true),
    autoStart: false
  });
  const handleBack = () => {
    clearStorages();
    window.location.replace('/dc/login');
  };

  useEffect(() => {
    if(!userTempToken){
      clearStorages();
      window.location.replace('/dc/login');
    }
    if (btnCountDown && qrCountDown) {
      dispatch(setCountTime({ btnCountTime: btnCountDown, qrCountTime: qrCountDown }));
    }
  }, []);
  useEffect(() => {
    if (btnCountTime) {
      restartBtnTimer(btnCountTime);
    }
  }, [btnCountTime, restartBtnTimer]);
  useEffect(() => {
    if (qrCountTime) {
      restartQrTimer(qrCountTime);
    }
  }, [qrCountTime, restartQrTimer]);

  return (
    <div className={styles['connect-app']}>
      <Card withBorder>
        <div className={styles['btn-back']}>
          <Button onClick={handleBack} style="transparent">
            <IconArrowLeft />
            <span>Keluar</span>
          </Button>
        </div>
        <h4>Hubungkan Aplikasi Authenticator</h4>
        <p>
          Untuk keamaan akun Anda, Anda perlu menghubungkan akun Anda dengan
          aplikasi authenticator. Kami telah mengirimkan panduan untuk
          menghubungkan aplikasi authenticator ke alamat email Anda&nbsp;
          <strong>({userData?.username})</strong>.
        </p>
        <div className={styles['box-warning']}>
          <IconWarning className={styles['ic-warning']} />
          <span>Harap hubungkan aplikasi authenticator dalam waktu kurang dari 60 menit.</span>
        </div>
        <Button disabled={isDisabled} onClick={() => navigate('/mfa/totp', { state: { qrCountDown } })}>Selanjutnya{seconds ? ` (${seconds})` : ''}</Button>
      </Card>
      <ModalExpiredToken opened={modal} />
    </div>
  );
};

export default ConnectApp;
